import {forOwn} from 'lodash';
import {push, replace} from 'redux-first-history';
import {ROUTER_REDUCER_STATE_ID} from 'src/js/common/constants';
import {StateId} from 'src/js/common/types';
import {FetcherUtils, getRouterLocationQuery} from 'src/js/common/utils';

import * as at from './location_action_types';
import {GLOBAL_PARAMETERS_PATH} from './location_constants';
import {encodeApiParameters} from './location_helpers';

function getNewLocation(params = {}, state: any = {}) {
  let result;
  const routerState = state[ROUTER_REDUCER_STATE_ID];
  const currentLocationSearch = decodeURI(routerState.location.search);
  const currentQueryWithParams = {...getRouterLocationQuery(state), ...params};
  const nextLocationSearch = `?${FetcherUtils.transformJSONToUrlEncodedParams({
    ...currentQueryWithParams,
  })}`;
  if (currentLocationSearch !== nextLocationSearch) {
    result = {
      pathname: routerState.location.pathname,
      search: nextLocationSearch,
    };
  }
  return result;
}

export function changeParams(
  stateId: StateId,
  params: Record<string, any>,
  reload: boolean,
  isGlobal = false,
  prefix: string | undefined = undefined
) {
  const definedParams: Record<string, any> = {};
  const prefixParams = encodeApiParameters(params, prefix);
  forOwn(prefixParams, (value, key) => {
    definedParams[key] = value ?? '';
  });
  return (dispatch, getState) => {
    const optionalPromises: Promise<any>[] = [];
    if (isGlobal) {
      // add param to global params
      optionalPromises.push(
        dispatch({
          type: at.CHANGE_PARAMS,
          payload: {
            params: definedParams,
            pathName: GLOBAL_PARAMETERS_PATH,
          },
          stateId,
        })
      );
    }
    return Promise.all([
      ...optionalPromises,
      dispatch({
        type: at.CHANGE_PARAMS,
        payload: {
          params: definedParams,
          pathName: getState()[ROUTER_REDUCER_STATE_ID].location.pathname,
        },
        stateId,
      }),
    ]).then(() => {
      const state = getState();

      // change location URL if necessary
      const newLocation = getNewLocation(state.location.parameters[state[ROUTER_REDUCER_STATE_ID].location.pathname], state);
      if (newLocation && !reload) {
        if (newLocation.pathname === window.location.pathname) {
          dispatch(replace(newLocation));
        } else {
          dispatch(push(newLocation));
        }
      }
    });
  };
}

export function navigateToRouteWithParams(stateId, route, additionalParams = {}) {
  return (dispatch, getState) => {
    const locationState = getState()[stateId];
    const searchString =
      locationState && locationState.parameters && locationState.parameters[route]
        ? `?${FetcherUtils.transformJSONToUrlEncodedParams({
            ...locationState.parameters[route],
            ...additionalParams,
          })}`
        : '';
    return dispatch(push(`${route}${searchString}`));
  };
}
